import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'removeFromArray',
    pure: false
})
export class RemoveFromArrayPipe implements PipeTransform {
    transform(mainArray: any[], objectsToRemove?: any[], property?: string): any[] | undefined {
        if (!mainArray || !objectsToRemove) {
            if (!mainArray) {
                return [];
            } else {
                return mainArray;
            }
        }

        if (!property) {
            property = 'ID';
        }

        return mainArray.filter((item) => !objectsToRemove.some((remove) => remove[property] === item[property]));
    }
}
